// First-impression copy shown by the root `grid` command. Kept in one
// module so the strings are unit-testable (index.ts runs the CLI on import and
// can't be imported in a test) and so a future polish pass has a single place
// to tune them. §23: plain, specific, confident, no marketing adjectives, no
// emoji, no exclamation marks.

/**
 * The one-line program description — the first thing a new builder sees when
 * they type `grid`. Concrete verb, no hedging about what isn't built yet.
 */
export const PROGRAM_DESCRIPTION = 'Put your apps and agents on the grid.';

/**
 * First-run orientation appended under the help command list. Three commands,
 * one path to a live URL, plus a one-line note that the same CLI answers to its
 * aliases. `grid` is the default invoker; `gridctl` is the canonical/spec name
 * (Decision 042); `cloudgrid` is the legacy alias. §23b: friendly, brief.
 */
export const FIRST_RUN_HELP = [
  '',
  'New here? Three commands to your first live URL:',
  '  grid login              sign in',
  '  grid init app <name>    start an app',
  '  grid plug               build it and go live',
  '',
  'Aliases: gridctl (canonical) and cloudgrid (legacy) run the same CLI.',
].join('\n');
